import { Injectable } from '@angular/core';
import { SignupData } from 'app/models/signup.model';

import { BehaviorSubject } from 'rxjs';
import { SessionStorageService } from '../session-storage/session-storage.service';

@Injectable({
    providedIn: 'root',
})
export class SignupService {
    private initialSignupData = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        hasSignupCompleted: false,
        plan: null,
        planIsYearly: false,
    };

    private signupDataSubject = new BehaviorSubject<SignupData>(
        this.initialSignupData
    );

    signupData$ = this.signupDataSubject.asObservable();

    constructor(private sessionStorageService: SessionStorageService) {}

    updateSignupData(newData: Partial<SignupData>) {
        const currentData = this.signupDataSubject.value;
        const updatedData = { ...currentData, ...newData };

        this.signupDataSubject.next(updatedData);

        const sessionUserData = {
            firstName: updatedData.firstName,
            lastName: updatedData.lastName,
            email: updatedData.email,
        };

        this.sessionStorageService.storeData(sessionUserData);
    }

    // Get current form data
    getSignupData(): SignupData {
        return this.signupDataSubject.value;
    }

    resetSignupData() {
        this.signupDataSubject.next(this.initialSignupData);
    }
}
